var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTriangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "13px",
    viewBox: "0 0 12 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CF4432EA-B228-4D7C-A236-2F18B68D5DFD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Universal-Modal-System-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UMS/Videos/01---Hover",
    transform: "translate(-218.000000, -480.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content/video",
    transform: "translate(187.000000, 295.340000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "thumbnail/video",
    transform: "translate(17.000000, 84.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "play-and-timer",
    transform: "translate(4.000000, 93.042236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7886919,10.5821179 L22.5551457,18.111606 C23.0493036,19.0994732 22.6490731,20.300892 21.6612059,20.79505 C21.3834105,20.9340108 21.0770667,21.0063581 20.7664538,21.0063581 L13.2335462,21.0063581 C12.1289767,21.0063581 11.2335462,20.1109276 11.2335462,19.0063581 C11.2335462,18.6957452 11.3058936,18.3894014 11.4448543,18.111606 L15.2113081,10.5821179 C15.7054661,9.59425067 16.9068849,9.1940202 17.8947521,9.68817815 C18.2815495,9.88166465 18.5952054,10.1953206 18.7886919,10.5821179 Z",
    id: "Triangle",
    transform: "translate(17.000000, 14.006358) rotate(-270.000000) translate(-17.000000, -14.006358) "
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle);
export default __webpack_public_path__ + "static/media/Triangle.ccba92c23fdcfd5a7e9c35264f991ce8.svg";
export { ForwardRef as ReactComponent };